export const DEFAULT_PHONE_FORMAT = '+1 (###) ###-####';
export const DEFAULT_PHONE_MASK = '_';
export const DEFAULT_DATE_FORMAT = 'MM/DD/yyyy';
